// @flow
import React from 'react';
import get from 'lodash/get';
import { useFormSubmitterContext } from '../form-submitter-context';
import resin from '../../../common/utils/resin';

const FormBeforeunloadAlert = () => {
  const { state } = useFormSubmitterContext();
  const { hasChange, submissionFailed, frUrlId } = state;
  const formResponseKey = get(state, 'uploader.formResponseKey');

  React.useEffect(() => {
    const beforeUnloadListener = () => {
      if (!submissionFailed && hasChange) {
        resin.recordAction({
          action: 'programmatic',
          page: 'file-request-submission',
          feature: 'filerequest',
          component: 'submissionpage',
          target: 'unload',
          data: {
            file_request_url_id: frUrlId,
            form_response_key: formResponseKey,
          },
        });
      }
    };

    window.addEventListener('beforeunload', beforeUnloadListener);

    return () => {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  });

  return <></>;
};

export { FormBeforeunloadAlert };
export default FormBeforeunloadAlert;
